import { render, staticRenderFns } from "./OfertaSolicitudDefault.vue?vue&type=template&id=2f8b6884"
import script from "./OfertaSolicitudDefault.vue?vue&type=script&lang=js"
export * from "./OfertaSolicitudDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8b6884')) {
      api.createRecord('2f8b6884', component.options)
    } else {
      api.reload('2f8b6884', component.options)
    }
    module.hot.accept("./OfertaSolicitudDefault.vue?vue&type=template&id=2f8b6884", function () {
      api.rerender('2f8b6884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/Ofertas/solicitud/OfertaSolicitudDefault.vue"
export default component.exports